<style scoped>
.link {
  color: rgb(217, 131, 166);
}
.row {
  vertical-align: top;
}
.main-body {
  min-height: 150px;
  padding: 5px;
  width: 100%;
  height: 100%;
  background-color: rgb(234, 236, 237);
}
.c926 {
  color: rgb(158, 83, 129);
  width: 100%;
  font-size: 50px;
}
.cell.c849 {
  width: 11%;
}
.c1144 {
  padding: 10px;
  font-size: 17px;
  font-weight: 300;
}
.card {
  min-height: 150px;
  padding: 5px;
  margin-bottom: 20px;
  height: 0px;
}
.card-cell {
  background-color: rgb(255, 255, 255);
  overflow: hidden;
  border-radius: 3px;
  padding: 0;
  text-align: center;
}
.card.sector {
  background-color: rgb(255, 255, 255);
  border-radius: 3px;
  border-collapse: separate;
}
.c1271 {
  width: 100%;
  margin: 0 0 15px 0;
  font-size: 50px;
  color: rgb(120, 197, 214);
  line-height: 250px;
  text-align: center;
}
.table100 {
  width: 100%;
}
.c1357 {
  min-height: 150px;
  padding: 5px;
  margin: auto;
  height: 0px;
}
.darkerfont {
  color: rgb(65, 69, 72);
}
.button {
  font-size: 12px;
  padding: 10px 20px;
  background-color: rgb(217, 131, 166);
  color: rgb(255, 255, 255);
  text-align: center;
  border-radius: 3px;
  font-weight: 300;
}
.table100.c1437 {
  text-align: left;
}
.cell.cell-bottom {
  text-align: center;
  height: 51px;
}
.card-title {
  font-size: 25px;
  font-weight: 300;
  color: rgb(68, 68, 68);
}
.card-content {
  font-size: 13px;
  line-height: 20px;
  color: rgb(111, 119, 125);
  padding: 10px 20px 0 20px;
  vertical-align: top;
}
/* .container {
  font-family: Helvetica, serif;
  min-height: 150px;
  padding: 5px;
  margin: auto;

  width: 90%;
  max-width: 550px;
} */
.cell.c856 {
  vertical-align: middle;
}
.container-cell {
  vertical-align: top;
  font-size: medium;
  padding-bottom: 50px;
}
.c1790 {
  min-height: 150px;
  padding: 5px;
  margin: auto;
  height: 0px;
}
.table100.c1790 {
  min-height: 30px;
  border-collapse: separate;
  margin: 0 0 10px 0;
}
.browser-link {
  font-size: 12px;
}
.top-cell {
  text-align: right;
  color: rgb(152, 156, 165);
}
.table100.c1357 {
  margin: 0;
  border-collapse: collapse;
}
.c1769 {
  width: 30%;
}
.c1776 {
  width: 70%;
}
.c1766 {
  margin: 0 auto 10px 0;
  padding: 5px;
  width: 100%;
  min-height: 30px;
}
.cell.c1769 {
  width: 11%;
}
.cell.c1776 {
  vertical-align: middle;
}
.c1542 {
  margin: 0 auto 10px auto;
  padding: 5px;
  width: 100%;
}
.card-footer {
  padding: 20px 0;
  text-align: center;
}
.c2280 {
  height: 150px;
  margin: 0 auto 10px auto;
  padding: 5px 5px 5px 5px;
  width: 100%;
}
.c2421 {
  padding: 10px;
}
.c2577 {
  padding: 10px;
}
.footer {
  margin-top: 50px;
  color: rgb(152, 156, 165);
  text-align: center;
  font-size: 11px;
  padding: 5px;
}
.quote {
  font-style: italic;
}

.list-item {
  height: auto;
  width: 100%;
  margin: 0 auto 10px auto;
  padding: 5px;
}
.list-item-cell {
  background-color: rgb(255, 255, 255);
  border-radius: 3px;
  overflow: hidden;
  padding: 0;
}
.list-cell-left {
  width: 30%;
  padding: 0;
}
.list-cell-right {
  width: 70%;
  color: rgb(111, 119, 125);
  font-size: 13px;
  line-height: 20px;
  padding: 10px 20px 0px 20px;
}
.list-item-content {
  border-collapse: collapse;
  margin: 0 auto;
  padding: 5px;
  height: 150px;
  width: 100%;
}
.list-item-image {
  color: rgb(217, 131, 166);
  font-size: 45px;
  width: 100%;
}
div#gjs-mdl-c {
    overflow: scroll;
    height: 100vh;
}
.gjs-block-label {
    line-height: normal;
    font-size: 14px;
    font-weight: normal;
    font-family: Helvetica, sans-serif;
    overflow: hidden;
    text-overflow: ellipsis;
}
.grid-item-image {
  line-height: 150px;
  font-size: 50px;
  color: rgb(120, 197, 214);
  margin-bottom: 15px;
  width: 100%;
}
.grid-item-row {
  margin: 0 auto 10px;
  padding: 5px 0;
  width: 100%;
}
.grid-item-card {
  width: 100%;
  padding: 5px 0;
  margin-bottom: 10px;
}
.grid-item-card-cell {
  background-color: rgb(255, 255, 255);
  overflow: hidden;
  border-radius: 3px;
  text-align: center;
  padding: 0;
}
.grid-item-card-content {
  font-size: 13px;
  color: rgb(111, 119, 125);
  padding: 0 10px 20px 10px;
  width: 100%;
  line-height: 20px;
}
.grid-item-cell2-l {
  vertical-align: top;
  padding-right: 10px;
  width: 50%;
}
.grid-item-cell2-r {
  vertical-align: top;
  padding-left: 10px;
  width: 50%;
}
.selected-email-panel {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  background: #ffffff;
  padding: 7px;
  border-radius: 9px;
}
.selected-email {
  background: #4444444f;
  border-radius: 22px;
  padding: 2px 8px;
  margin-right: 11px;
  margin-bottom: 5px;
}
.selected-email .close {
  margin: 0 0 0 11px;
  background: #f44336;
  border-radius: 50%;
  height: 117px;
  width: 59px;
  padding: 0 3px;
  color: white;
  cursor: pointer;
}
span.selected-email:after {
  content: ',';
  margin-left: 10px;
  position: absolute;
}
.contact-group {
  width: 20%;
  border-right: solid #9a9a9a 1px;
}
.contact-group li {
  padding: 6px;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
}
.contact-group li.active {
  background-color: #b8b8b8;
}
.clist {
  max-height: 453px;
  min-height: 250px;
  overflow: auto;
}
.contact-list {
  width: 80%;
  padding-left: 1rem;
}
.contact-list ul.clist li {
  padding: 5px 0;
  border-bottom: solid #9a9a9a 0.5px;
  display: flex;
  justify-content: space-between;
  cursor: pointer;
}
.gjs-mdl-content {
  background: #ececec;
}
.gjs-mdl-container {
  z-index: 999 !important;
}
.gjs-import-label {
  color: #000;
}
.gjs-btn-prim {
  background: black;
}
label {
  color: black;
}
.subject {
  width: 100%;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  background: #ffffff;
  border-radius: 9px;
  height: 40px;
}
</style>

<template lang="pug">
.main-content-padded
  .row
    #id.col.m12

    input#code(type='hidden', name='body')

    #sendemailTransaction(style='display: none; color: white !important')
      div(style='color: #2b2a2a')
        label Enter subject
          input.subject(type='text', v-model='newsletterSubject', required='')
        div
          p Enter an email
          label Enter one or more email addresses separated by commas (,).
          .selected-email-panel
            span(style='width: 230px; margin: 0 10px 0 0;')
              input(style='height: 24px; margin: 0 10px 0 0;')(
                type='email',
                placeholder='Email',
                v-model='inputEmail',
                v-on:keyup.enter='addEmailToList($event)',
                @input='checkValidEmail($event)'
              )
            span.selected-email(v-for='(email, index) in selectedsubs') {{ email }}
              label.close(@click='removeEmail(index)') x
        div(style='margin-top: 17px;')
          button.btn.btn-small(
            style='float: right; display: flex',
            @click='sendNewsletter',
            :disabled='!newsletterSubject || selectedsubs.length === 0'
          )
            span send&nbsp;
            i.material-icons send
        div(style='margin-top: 40px')
          label Or select from your contact list.
          hr
        div(style='display: flex')
          .contact-group
            ul
              li(
                v-bind:class='{ active: selectedContactGroup === clist.id }',
                v-for='(clist, index) in contactList.lists',
                @click='getSubscibers(clist.id)'
              )
                span {{ clist.name }}
                span {{ clist.uniqueSubscribers }}
          .contact-list(v-if='selectedContactGroup')
            v-app
              v-card
                v-card-title
                   button.btn.btn-small(@click='selectAll(subcribers.contacts)') Select All
                v-data-table(
                  :headers='headers',
                  :items='subcribers.contacts',
                   :items-per-page="5",
                  :total-items='pagination.totalItems',
                  :loading='isLoading',
                  prev-icon='arrow_left',
                  next-icon='arrow_right',
                  sort-icon='arrow_drop_up'
                )
                  template(v-slot:items='props')
                    td
                      a(@click='selectEmail(props.item.email)', href='#') {{props.item.email}}
                    td.text-xs-left
                      span
                        i.red-text.material-icons(v-if='isSelected(props.item.email)') done

      #modalSave(style='display: none')
        label Subject
          input(type='text', v-model='template.subject', required='')
        label title
          input(type='text', v-model='template.templateName', required='')
        button.gjs-btn-prim.gjs-btn-import(@click='save', style='width: 100%') save

  //- form#sendemailTransaction.sendemailTransaction(action='http://grapes.16mb.com/s', method='POST', style='display:none')
  //-   .gjs-sm-property
  //-     .gjs-field
  //-       span#gjs-sm-input-holder
  //-         input(type='email', name='email', placeholder='Email', required='')
  //-   .gjs-sm-property
  //-     .gjs-field
  //-       span#gjs-sm-input-holder
  //-         input(type='text', name='subject', placeholder='Subject', required='')
  //-   input(type='hidden', name='body')
  //-   button.gjs-btn-prim.gjs-btn-import(style='width: 100%') SEND
</template>

<script>
import axios from 'axios'
import grapesjs from 'grapesjs'
// require('grapesjs-preset-newsletter')
// require('grapesjs/dist/grapes.min.js')
require('grapesjs-preset-newsletter/dist/grapesjs-preset-newsletter.css')
require('grapesjs-preset-newsletter/dist/grapesjs-preset-newsletter.min.js')
require('grapesjs/dist/css/grapes.min.css')
export default {
  meta: {
    title: 'Newsletter'
  },
  props: {
    id: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      editor: null,
      newsletterBody: '',
      newsletterSubject: '',
      emailContent: {},
      defaultEmailTemplate: '',
      template: {
        sender: null,
        templateName: null,
        htmlContent: null,
        subject: null,
        isActive: null,
      },
      contactList: [],
      subcribers: [],
      selectedContactGroup: null,
      selectedsubs: [],
      inputEmail: '',
      selectedContGroup: null,
      headers: [
        { text: 'email',  sortable: false, value: 'email', width: '80%' },
        { text: 'Action',  sortable: false, value: '', width: '20%' },

      ],
      singleSelect: false,
        selected: [],
      pagination: {
        descending: true,
        sortBy: 'createdAt',
      },
      isLoading: false,
      totalItems: 0
    }
  },
  computed: {
    defaultEmail() {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        axios
          .get(`${this.$config.API_URL}/admin/sib-defaultTemplate/3/`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((result) => {
            this.defaultEmailTemplate = result.data.htmlContent
            LandingPage.html = result.data.htmlContent
            return result.data.htmlContent
          })
      })
    },
  },

  // computed: {
  //   nlbody () {
  //     let contentEl = document.getElementById('code')
  //     return contentEl.value
  //   }
  // },
  mounted() {
    const LandingPage = {
      html: null,
      css: null,
      components: null,
      style: null,
    }

    this.editor = grapesjs.init({
      container: '#id',
      fromElement: false,
      storageManager: {
        autoload: 0,
      },
      //  components: this.defaultEmailTemplate,
      // // We might want to make the same check for styles
      // style: LandingPage.style || LandingPage.css,
      assetManager: {
        assets: [
          'https://inom.ph/static/img/inomph_logo_md.png',
          {
            type: 'image',
            src: 'https://inom.ph/static/img/inomph_logo_md.png',
            height: 350,
            width: 250,
          },
          {
            src: 'http://placehold.it/350x250/79c267/fff/image3.jpg',
            height: 350,
            width: 250,
          },
        ],
        uploadText: 'Uploading is not available in this demo',
        // upload: `http://192.168.1.6:3000/publicsd`,
        // The name used in POST to pass uploaded files, default: `'files'`
        uploadName: 'files',
        storageType: '',
        storeOnChange: true,
        storeAfterUpload: true,
      },
      plugins: ['gjs-preset-newsletter'],
      pluginsOpts: {
        'gjs-preset-newsletter': {
          modalLabelImport: 'Paste all your code here below and click import',
          modalLabelExport: 'Copy the code and use it wherever you want',
          importPlaceholder:
            '<table class="table"><tr><td class="cell">Hello world!</td></tr></table>',
          cellStyle: {
            'font-weight': 300,
            'vertical-align': 'top',
            color: 'rgb(111, 119, 125)',
            margin: 0,
            padding: 0,
          },
        },
      },
      blockManager: {},
      // deviceManager: {}
    })

    this.editor.getConfig().showDevices = 0
    this.editor.Panels.addPanel({ id: 'devices-c' })
      .get('buttons')
      .add([
        {
          id: 'set-device-tablet',
          command: function (e) {
            return e.setDevice('mobile2')
          },
          className: 'fa fa-mobile',
        },
        {
          id: 'set-device-mobile',
          command: function (e) {
            return e.setDevice('Mobileportrait')
          },
          className: 'fa fa-mobile',
        },
      ])

    // Panel should re render again otherwise
    // New button will not be shown on device panel
    this.editor.Panels.render()
    let deviceManager = this.editor.DeviceManager
    deviceManager.add('mobile2', '414px')
    deviceManager.add('Mobileportrait', '900px', {
      height: '300px',
      name: 'new tab',
      widthMedia: '10px',
    })
    // Let's add in this demo the possibility to test our newsletters
    let mdlClass = 'gjs-mdl-dialog-md'
    let pnm = this.editor.Panels
    let cmdm = this.editor.Commands
    let testContainer = document.getElementById('sendemailTransaction')
    let modalSaveContainer = document.getElementById('modalSave')

    let contentEl = document.getElementById('code')
    // testContainer.querySelector('input[name=body]')
    let md = this.editor.Modal
    cmdm.add('send-test', {
      run(editor, sender) {
        // sender.set('active', 0)
        // let modalContent = md.getContentEl()
        let mdlDialog = document.querySelector('.gjs-mdl-dialog')
        let cmdGetCode = cmdm.get('gjs-get-inlined-html')
        contentEl.value = cmdGetCode && cmdGetCode.run(editor)
        mdlDialog.className += ' ' + mdlClass
        this.newsletterBody = 'hi'
        testContainer.style.display = 'block'
        md.setTitle('Send a Newsletter')
        md.setContent('')
        md.setContent(testContainer)
        md.open()
        md.getModel().once('change:open', function () {
          mdlDialog.className = mdlDialog.className.replace(mdlClass, '')
        })
      },
      stop(editor, sender) {
        console.log('!!!!!!!!!!!!!!!!!')
      },
    })
    cmdm.add('save-temp', {
      run(editor, sender) {
        let contentEl = document.getElementById('code')
        let cmdGetCode = cmdm.get('gjs-get-inlined-html')
        contentEl.value = cmdGetCode && cmdGetCode.run(editor)
        this.newsletterBody = cmdGetCode && cmdGetCode.run(editor)
        let mdlDialog = document.querySelector('.gjs-mdl-dialog')
        modalSaveContainer.style.display = 'block'
        md.setTitle('Save Template')
        md.setContent('')
        md.setContent(modalSaveContainer)
        md.open()
        md.getModel().once('change:open', function () {
          mdlDialog.className = mdlDialog.className.replace(mdlClass, '')
        })
      },
      stop(editor, sender) {
        console.log('vlosew')
      },
    })

    pnm.addButton('options', {
      id: 'send-test',
      className: 'fa fa-paper-plane',
      command: 'send-test',
      attributes: {
        title: 'Send Newsletter',
        'data-tooltip-pos': 'bottom',
      },
    })
    pnm.addButton('options', {
      id: 'save-template',
      className: 'fa fa-save',
      command: 'save-temp',
      attributes: {
        title: 'save',
        'data-tooltip-pos': 'bottom',
      },
    })

    const blockManager = this.editor.BlockManager

    blockManager.add('h1-block', {
      label: 'test custom block here',
      content: '<h1>Put your title here</h1> <p>sample only by dev</p>',
      category: 'Custom Blocks',
      attributes: {
        title: 'Insert h1 block',
      },
    })
    blockManager.add('header-block', {
      label: 'inom header',
      content:
        '<h1>header</h1><h1>Put your title here</h1> <p>sample only by dev</p>',
      category: 'Custom Blocks',
      attributes: {
        title: 'Insert h1 block',
      },
    })
    blockManager.add('footer-block', {
      label: 'inom footer',
      content: '<h1>this is footer</p>',
      category: 'Custom Blocks',
      attributes: {
        title: 'Insert h1 block',
      },
    })

    this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
      axios
        .get(`${this.$config.API_URL}/admin/sib-defaultTemplate/4/`, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        })
        .then((result) => {
          this.defaultEmailTemplate = result.data.htmlContent
          this.template = {
            sender: {
              name: result.data.sender.name,
              email: result.data.sender.email,
            },
            templateName: null,
            htmlContent: result.data.htmlContent,
            subject: null,
            isActive: result.data.isActive,
          }
          this.editor.addComponents(result.data.htmlContent)
        })
    })
    this.editor.on('run', (commandId) => {
      this.editor.Commands.stop('sw-visibility')
      this.editor.Commands.isActive('sw-visibility')
    })
    // this.editor.on('change', this.change)

    this.getContactList()
  },
  methods: {
    addEmailToList(ev) {
      let newEmail = ev.target.value
      if (this.emailValidarion(newEmail)) {
        if (this.selectedsubs.indexOf(newEmail) !== -1) {
          this.inputEmail = ''
        } else {
          this.selectedsubs.push(newEmail)
          this.inputEmail = ''
        }
      }
    },
    checkValidEmail(event) {
      let newEmail = event.target.value
      if (newEmail.indexOf(',') > -1) {
        newEmail = newEmail.split(',')
        console.log(newEmail[0])
        if (this.emailValidarion(newEmail[0])) {
          if (this.selectedsubs.indexOf(newEmail[0]) !== -1) {
            this.inputEmail = ''
          } else {
            this.selectedsubs.push(newEmail[0])
            this.inputEmail = ''
          }
        }
      }
    },
    emailValidarion(email) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(String(email).toLowerCase())
    },
    removeEmail(i) {
      let start = i
      console.log(start)
      this.selectedsubs.splice(start, 1)
    },
    getContactList() {
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        axios
          .get(`${this.$config.API_URL}/admin/sib-get-contact-groups`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
            },
          })
          .then((result) => {
            this.contactList = result.data
          })
      })
    },
    getSubscibers(listID) {
      this.selectedContactGroup = listID
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        axios
          .get(
            `${this.$config.API_URL}/admin/sib-get-contact-groups-subs/${listID}`,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          )
          .then((result) => {
            this.subcribers = result.data
          })
      })
    },
    selectAll(contact) {
      for (let index = 0; index < contact.length; index++) {
        const element = contact[index]
        if (this.selectedsubs.indexOf(element.email) !== -1) {
          continue
        } else {
          this.selectedsubs.push(element.email)
        }
      }
      console.log(this.selectedsubs)
    },
    selectEmail(email) {
      if (this.selectedsubs.indexOf(email) !== -1) {
        console.log('exixst', this.selectedsubs.indexOf(email))
        this.selectedsubs.splice(this.selectedsubs.indexOf(email), 1)
      } else {
        this.selectedsubs.push(email)
      }
    },
    isSelected(email) {
      if (this.selectedsubs.indexOf(email) !== -1) {
        return true
      } else {
        // alert("Value does not exists!")
        return false
      }
    },
    save() {
      let contentEl = document.getElementById('code')
      this.template.htmlContent = contentEl.value
      console.log(this.template)
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        axios
          .post(
            `${this.$config.API_URL}/admin/sib-create-email-template`,
            this.template,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          )
          .then((result) => {
            this.$snackbar.show({ text: 'Template Successfully created!' })
          })
      })
    },
    sendNewsletter() {
      let contentEl = document.getElementById('code')
      this.emailContent = {
        htmlContent: contentEl.value,
        NLsubject: this.newsletterSubject,
        contacts: this.selectedsubs,
      }
      this.$store.dispatch('auth/getAccessToken').then((accessToken) => {
        axios
          .post(
            `${this.$config.API_URL}/admin/sib-send-news-letter`,
            this.emailContent,
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          )
          .then((result) => {
            // this.contstr = {to: null, message: null}
            this.$snackbar.show({ text: 'Message Successfully sent!' })
          })
      })
    },
  },
}
</script>




// WEBPACK FOOTER //
// src/components/page-newsletter.vue